import React from "react";
import { transformToHtml } from "../../../utils/CommonUtils";
import FlightStatusListingCard from "../FlightStatusListing/FlightStatusListingCard";

export default function FlightStatusRouteListing({ listing, h1Header, showListingTitle = true }) {
  if (!listing?.cards?.length) return null;

  const headerTitle = listing.title || h1Header || "";

  return (
    <section className="fs-route-listing" aria-label={headerTitle || "Route flight status listing"}>
      {showListingTitle && headerTitle ? (
        <div className="fs-route-listing__header">
          <h1 className="fs-route-listing__title">{transformToHtml(headerTitle)}</h1>
        </div>
      ) : null}
      <ul className="fs-route-listing__list">
        {listing.cards.map((card) => (
          <FlightStatusListingCard key={card.key} card={card} />
        ))}
      </ul>
    </section>
  );
}
